
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import upload from "@/components/upload/src/index.vue";
  import {getItemInfo, updateItemInfo} from '@/services/api';
  import validator from "@/services/validator";

  @Component({
    components: {
      'zf-breadcrumb': breadcrumb,
      'zf-upload': upload
    },
  })
  export default class ItemModify extends Vue{
    //面包屑导航
    public navList: {name: String, to?: String}[] = [
      {name: '审核列表', to: '/item/list'},
      {name: '落地页修改'}
    ];
    //编辑的itemId
    private itemId!: number;
    //临时落地页
    public landingPageUrl?: string = '';
    //显示的表单信息
    public itemForm: any = {
      itemId: 0,
      itemTitle: '',   //item标题
      itemPrice: 0,   //item价格
      goodList: [
        {
          goodId: 0,
          goodTitle: '',  //套餐名称
          goodPrice: 0    //套餐价格
        }
      ]
    };

    // 上传图片地址
    public uploadUrl = (process.env.VUE_APP_BASE_API.length == 0 ? (location.origin + "/") : process.env.VUE_APP_BASE_API) + 'api/audit_interface/uploadImages';
    // 轮播图回显列表
    public coverShowList: {url: string, name: string}[] = [];
    // 轮播图上传列表
    public coverList: {url: string, name: string}[] = [];
    // 详情图回显列表
    public detailShowList: {url: string, name: string}[] = [];
    // 详情图上传列表
    public detailList: {url: string, name: string}[] = [];
    // 大图展示控制
    public dialogVisible = false;
    // 大图展示路径
    public dialogImageUrl = '';

    created(): void {
      this.itemId = Number(this.$route.query.itemId);
      console.log('itemId:'+this.itemId);
      this.getItemInfo();
    }

    /**
     * 图片删除前确认钩子函数
     */
    beforeRemove() {
        console.log(this.uploadUrl)
      return this.$confirm(`确定移除该图片吗？`);
    }

    /**
     * 轮播图删除钩子函数
     */
    handleRemove(file: {name: string, url: string}, list: any) {
      this.coverList = [...list];
      this.coverShowList = [...list];
    }

    /**
     * 轮播图上传成功钩子函数
     */
    handleSuccess(res: any,file: any,fileList: any) {
      if (res && res['result'][0]) {
        file.url = res['result'][0]
        // 图片根据上传顺序重新排序
        let front;
        for (let [index, item] of fileList.entries()) {
          if(item.status !== 'success' && !front) {
            front = index;
          }
          if (item.uid === file.uid && front) {
            fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
            break;
          }
          this.coverShowList = fileList;
        }
        this.coverList.push(file)
      }
    }

    /**
     * 详情图删除钩子函数
     */
    handleRemove1(file: {name: string, url: string}, list: any) {
      this.detailList = [...list];
      this.detailShowList = [...list];
    }

    /**
     * 详情图上传成功钩子函数
     */
    handleSuccess1(res: any,file: any,fileList: any) {
      if (res && res['result'][0]) {
        file.url = res['result'][0]
        // 图片根据上传顺序重新排序
        let front;
        for (let [index, item] of fileList.entries()) {
          if(item.status !== 'success' && !front) {
            front = index;
          }
          if (item.uid === file.uid && front) {
            fileList.splice(front,1,...fileList.splice(index, 1 , fileList[front]))
            break;
          }
          this.detailShowList = fileList;
        }
        this.detailList.push(file)
      }
    }

    /**
     * 图片上传失败钩子函数
     */
    handleError(e: any): void {
      this.$message.warning('图片上传失败！');
      if(e.status === 401) {
        // 如果返回401 即没有权限，跳到登录页重新登录
        this.$alert('登录失效，请重新登录')
        this.$router.replace({
          path: '/login',
          query: {redirect: this.$router.currentRoute.fullPath}
        })
      }
    }

    /**
     * 图片展示
     */
    handlePictureCardPreview(file: {name: string, url: string}) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true;
    }

    /**
     * 获取item信息
     */
    async getItemInfo(): Promise<void> {
      if (this.itemId) {
        await getItemInfo(this.itemId, true).then(res => {
          if (res.data && res.data.result) {
            this.itemForm = res.data.result;
            this.landingPageUrl = res.data.result.landingPageUrl;
            this.coverList = res.data.result.covers.map((url: string) => ({
              name: '',
              url
            }))
            this.coverShowList = [...this.coverList]
            this.detailList = res.data.result.details.map((url: string) => ({
              name: '',
              url
            }))
            this.detailShowList = [...this.detailList]
          }
        });
      }
    }

    /**
     * 保存表单
     */
    onSubmit(itemForm :any): void {
      if (this.checkForm()){
        this.updateItemInfo();
      }
    }

    /**
     * 更新item和套餐信息
     */
    updateItemInfo(): void {
      this.itemForm.covers = this.coverList.map(item => item.url)
      this.itemForm.details = this.detailList.map(item => item.url)
      updateItemInfo(this.itemForm).then(res =>{
        if (res.data && res.data.status==='OK'){
          // this.$router.go(-1);
          this.$message({
            showClose: true,
            message: '修改成功！',
            type: 'success'
          });
          // 保存成功页面等待1秒重新加载数据
          let self = this;
          setTimeout(function () {
            self.getItemInfo();
          }, 1000);
        }else {
          this.$message({
            showClose: true,
            message: '修改失败，请检查网络后重试！',
            type: 'warning'
          });
        }
      });
    };

    /**
     * 校验表单内容是否通过
     */
    checkForm(): boolean {
      if (!this.testRequired(validator({required:true, requiredMsg: '产品标题不能为空'}, this.itemForm.itemTitle))){
        return false;
      }
      if (!this.testRequired(validator({required:true, requiredMsg: '产品价格不能为空', type: 'price'}, this.itemForm.itemPrice))){
        return false;
      }
      for (const x in this.itemForm.goodList) {
        if (!this.testRequired(validator({required:true, requiredMsg: '套餐名称不能为空'}, this.itemForm.goodList[x].goodTitle))){
          return false;
        }
        if (!this.testRequired(validator({required:true, requiredMsg: '套餐价格不能为空', type: 'price'}, this.itemForm.goodList[x].goodPrice))){
          return false;
        }
      }
      return true;
    }

    /**
     * 取消方法
     */
    cancel() {
      this.$router.push('/');
    }

    /**
     * 表单验证提示
     * @param msg 错误信息
     * @return boolean 检测通过，没有错误信息为true
     */
    testRequired(msg: string | undefined): boolean {
      if (msg) {
        this.$message.error(msg);
        return false;
      } else {
        return true;
      }
    }
  }
